/**
 * Absence Email Settings Page (E19-5: MED-501)
 * Template management and rule configuration for absence emails.
 */

import { Tabs, Container, Title, Stack } from '@mantine/core';
import { Mail, Settings } from 'lucide-react';
import { AbsenceTemplateList } from './components/AbsenceTemplateList';
import { AbsenceRuleConfig } from './components/AbsenceRuleConfig';

export function AbsenceEmailSettingsPage() {
  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        <Title order={2} fw={700} fz={32}>
          Absence Email Settings
        </Title>

        <Tabs defaultValue="templates" keepMounted={false}>
          <Tabs.List>
            <Tabs.Tab value="templates" leftSection={<Mail size={14} />}>
              Email Templates
            </Tabs.Tab>
            <Tabs.Tab value="rules" leftSection={<Settings size={14} />}>
              Rule Configuration
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="templates" pt="md">
            <AbsenceTemplateList />
          </Tabs.Panel>

          <Tabs.Panel value="rules" pt="md">
            <AbsenceRuleConfig />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </Container>
  );
}

export default AbsenceEmailSettingsPage;
